var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _vm.$userIsUnverified ? _c("dashboard-verify-email-alert") : _vm._e(),
      _vm._v(" "),
      _vm.$userIsTalent
        ? _c("div", { staticClass: "alert alert-info alert-icon" }, [
            _c("i", { staticClass: "fa fa-info" }),
            _vm._v(
              "\n    " +
                _vm._s(_vm.clientName) +
                " now has a mobile app making it even easier to manage your " +
                _vm._s(_vm.$t("requests")) +
                "! Download it for iPhone and Android "
            ),
            _c("a", { attrs: { target: "_blank", href: _vm.mobileLink } }, [
              _vm._v("here"),
            ]),
            _vm._v("!\n  "),
          ])
        : _vm.$userIsTalent && _vm.$userIsPending
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("div", { staticClass: "alert alert-info alert-icon" }, [
              _c("i", { staticClass: "fa fa-info" }),
              _vm._v(
                "\n\n      Your account is pending admin verification.\n      You can not submit a " +
                  _vm._s(_vm.$t("booking request")) +
                  " until your account is verified.\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$chatsModuleEnabled
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("h2", { staticClass: "has-button" }, [
              _vm._v(
                "\n      Your Inbox\n      –\n      " +
                  _vm._s(_vm.lists.active_threads_count) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _vm.haveNoActiveThreads
              ? _c("div", { staticClass: "text-center alert alert-default" }, [
                  _vm._v("\n      There are no active chats\n    "),
                ])
              : _c(
                  "ul",
                  { staticClass: "list-items" },
                  _vm._l(_vm.activeThreads, function (thread) {
                    return _c("thread-list-item", {
                      key: thread.id,
                      attrs: { thread: thread, booking: thread.booking },
                    })
                  }),
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-info",
                    staticStyle: { "letter-spacing": "2px" },
                    attrs: { to: { name: "threads.index" } },
                  },
                  [_vm._v("View All")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "dashboard-block" }, [
        _c(
          "h2",
          [
            _vm._v("\n      Your " + _vm._s(_vm.$t("Requests")) + "\n      "),
            _c("media", { attrs: { query: { minWidth: 437 } } }, [
              _c("small", [
                _vm._v(
                  "- (showing " +
                    _vm._s(_vm.requests.length) +
                    " of " +
                    _vm._s(this.lists.requests_count) +
                    ")"
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.haveNoBookingRequests
          ? _c("div", { staticClass: "text-center alert alert-default" }, [
              _vm._v(
                "\n      You have no " +
                  _vm._s(_vm.$t("booking requests")) +
                  " pending response.\n    "
              ),
            ])
          : _c(
              "ul",
              { staticClass: "list-items" },
              _vm._l(_vm.requests, function (booking) {
                return _c("talent-dashboard-booking-requests-list-item", {
                  key: booking.id,
                  attrs: { booking: booking },
                })
              }),
              1
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-right" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-info",
                staticStyle: { "letter-spacing": "2px" },
                attrs: { to: { name: "requests.index" } },
              },
              [_vm._v("View All")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", [
          _vm._v("\n      Your Bookings\n      "),
          _c("small", [
            _vm._v(
              "- (showing " +
                _vm._s(_vm.bookings.length) +
                " of " +
                _vm._s(this.lists.bookings_count) +
                ")"
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.haveNoBookings
          ? _c("div", { staticClass: "text-center alert alert-default" }, [
              _vm._v("\n      You have no upcoming Bookings.\n    "),
            ])
          : _c(
              "ul",
              { staticClass: "list-items" },
              _vm._l(_vm.bookings, function (booking) {
                return _c("talent-dashboard-booking-list-item", {
                  key: booking.id,
                  attrs: { booking: booking },
                })
              }),
              1
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-right" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-info",
                staticStyle: { "letter-spacing": "2px" },
                attrs: { to: { name: "bookings.index" } },
              },
              [_vm._v("View All")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }